import React from "react";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import Paginacion from "../../../../../../Utils/Components/Paginacion/Paginacion";
import CardEmpty from "Utils/Cards/CardEmpty";
import { useSemanasPendientes } from "../hooks/useSemanasPendientes";
import { FiltroPadrePT } from "../../../../components/FiltroPadrePT/FiltroPadrePT";
import { ModalKgMiga } from "./ModalKgMiga";

const descripcionSemana = (semana) =>
    `${semana.etiqueta} del ${semana.anio} (${semana.rango}) · ${semana.padre_producto_terminado.nombre}`;

export const SemanasPendientes = ({ tabActiva, regresar }) => {
    const hook = useSemanasPendientes({ tabActiva });

    const semanaSeleccionada = hook.semanaSeleccionada;

    return (
        <div className="view__tab-wrapper">
            <LoadMask loading={hook.cargando} blur>
                <CardEmpty noShadow>
                    <FiltroPadrePT hook={hook} />

                    <div className="new-table-wrapper miga-desecho__table-wrapper">
                        <table className="table-striped">
                            <thead>
                                <tr>
                                    <th>SEMANA</th>
                                    <th>RANGO</th>
                                    <th>PADRE PT</th>
                                    <th>ESTADO</th>
                                    <th>ACCIONES</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hook.semanas.length === 0 && (
                                    <tr>
                                        <td className="text-center" colSpan={5}>
                                            No hay semanas pendientes de
                                            reportar
                                        </td>
                                    </tr>
                                )}

                                {hook.semanas.map((semana) => (
                                    <tr
                                        key={`${semana.anio}-${semana.semana}-${semana.padre_producto_terminado.id}`}
                                    >
                                        <td className="text-center text-nowrap">
                                            {`${semana.etiqueta} - ${semana.anio}`}
                                        </td>
                                        <td className="text-center text-nowrap">
                                            {semana.rango}
                                        </td>
                                        <td className="text-center text-nowrap">
                                            {
                                                semana.padre_producto_terminado
                                                    .nombre
                                            }
                                        </td>
                                        <td className="text-center text-nowrap">
                                            {semana.tiene_turno_en_curso ? (
                                                <span className="text-warning font-weight-bold">
                                                    Turno en curso
                                                </span>
                                            ) : (
                                                "Pendiente"
                                            )}
                                        </td>
                                        <td className="text-center text-nowrap">
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm"
                                                disabled={
                                                    semana.tiene_turno_en_curso
                                                }
                                                title={
                                                    semana.tiene_turno_en_curso
                                                        ? "La semana tiene un turno en curso; podrá reportarse cuando el turno finalice."
                                                        : "Reportar la miga de esta semana"
                                                }
                                                onClick={() =>
                                                    hook.AbrirModalReporte(
                                                        semana,
                                                    )
                                                }
                                            >
                                                Reportar miga
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <Paginacion
                        cantidadResultados={hook.cantidadResultados}
                        paginaSeleccionada={hook.paginaSeleccionada}
                        setPaginaSeleccionada={hook.setPaginaSeleccionada}
                    />

                    <div className="d-flex justify-content-center mt-3 mb-3">
                        <button
                            className="btn btn-outline-dark"
                            onClick={regresar}
                        >
                            Regresar
                        </button>
                    </div>

                    {semanaSeleccionada && (
                        <ModalKgMiga
                            abierto={true}
                            onCerrar={hook.CerrarModalReporte}
                            titulo="Reportar miga de desecho"
                            descripcion={descripcionSemana(semanaSeleccionada)}
                            kgHumedos={hook.kgHumedosInput}
                            setKgHumedos={hook.setKgHumedosInput}
                            semanasEnCero={
                                semanaSeleccionada.semanas_anteriores_pendientes
                            }
                            onConfirmar={hook.ReportarMiga}
                            textoConfirmar="Reportar"
                            cargando={hook.cargando}
                        />
                    )}
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
